import Big from 'big.js';
import {BehaviorSubject, combineLatest, Subject} from 'rxjs';
import {map, skipUntil, switchMap} from 'rxjs/operators';
import {numUtil} from '@/helper/num';
import {timeUtil} from '@/helper/time';
import {marginTradeApi} from '@/api/margin-trade';
import {mc} from '@/core';
import {browser$} from '@/streams/browser';
import {marginCurrencyMap$} from '@/streams/config/margin-trade';

export const BusinessMap = {
  0: 'ManualRepay',
  2: 'MarginRepay',
  3: 'UtaSpotRepay',
  4: 'UtaMarginRepay',
};

export const typeMap = {
  0: 'ManualRepay',
  1: 'AutoRepay',
  2: 'LiquidationRepay',
};

export const loading$ = new Subject();
export const query$ = new Subject();
const repay$ = new BehaviorSubject({total: 0, rows: []});
export const repayList$ = combineLatest([repay$, marginCurrencyMap$]).pipe(map(convertData));

const Limit = 10;

query$
  .pipe(
    skipUntil(browser$),
    switchMap((query) => loadRepayList(query))
  )
  .subscribe((x) => repay$.next(x));

async function loadRepayList({current, currency, business}) {
  loading$.next(true);
  const query = {
    business,
    currency,
    pageNum: current,
    pageSize: Limit,
  };
  const {data, error} = await marginTradeApi.getRepayHistory(query);
  loading$.next(false);
  if (data) {
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return {total: 0, rows: []};
}

function convertData([data, currencyMap]) {
  const {rows, total} = data;
  const list = rows.map((o) => {
    const {valuePrecision = 8} = currencyMap[o.currency] || {};
    const totalRepayAmount = Big(o.principalAmountRv).plus(o.interestAmountRv);
    return {
      repayCurrency: o.currency,
      repayTime: timeUtil.formatDateTime(o.repayTime),
      principalAmount: numUtil.trimEnd0(o.principalAmountRv) === '0' ? 0 : numUtil.floor(o.principalAmountRv, valuePrecision, 0),
      interestAmount: numUtil.trimEnd0(o.interestAmountRv) === '0' ? 0 : numUtil.floor(o.interestAmountRv, valuePrecision, 0),
      totalRepayAmount: numUtil.trimEnd0(totalRepayAmount.toString()) === '0' ? 0 : numUtil.floor(totalRepayAmount, valuePrecision, 0),
      liquidationFee: numUtil.trimEnd0(o.liqFeeRv) === '0' ? 0 : numUtil.floor(o.liqFeeRv, valuePrecision, 0),
      type: o.type,
      status: o.status,
      business: o.business,
    };
  });
  return {rows: list, total};
}
